import { render, staticRenderFns } from "./SendAnnouncement.vue?vue&type=template&id=05f43cc2&scoped=true&"
import script from "./SendAnnouncement.vue?vue&type=script&lang=js&"
export * from "./SendAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f43cc2",
  null
  
)

export default component.exports